import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React, { useContext, useMemo, useState } from 'react';
import { Asset } from '../../../../types/asset/asset';
import { useMutation } from '@apollo/client';
import { Grid } from '@mui/material';
import Modal from '../../../../VentoryUI/components/common/Modal';
import { t } from '../../../../types/translation/Translator';
import AssetInfoPane, { AssetInfoType } from './Panes/AssetInfoPane';
import { AssetInput } from '../../../../types/asset/asset.input';
import { AssetTransactionContext } from '../../../../context/AssetTransactionContext';
import { CancelButton, UpdateButton } from '../../../components/Button';
import {
  AssetTransactionMutations,
  UpdateAssetTransactionResponse,
  UpdateAssetTransactionVariables,
} from '../../../../graphql/assetTransaction.graphql';

interface AssetTransactionUpdateModalInputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  asset?: Asset;
}

export default function AssetTransactionUpdateModal({ open, setOpen, asset }: AssetTransactionUpdateModalInputProps) {
  if (!asset) return null;

  const { assetTransactions, setAssetTransactions } = useContext(AssetTransactionContext);

  const [input, setInput] = useState<AssetInput>(
    new AssetInput({ ...asset, product: { ...asset.product, quantity: 1, unitQuantity: '1' } }),
  );
  const [error, setError] = useState<string>('');

  const availableQuantity = useMemo(() => {
    return asset.product.quantity;
  }, [asset]);

  const [update, { loading: updateLoading }] = useMutation<
    UpdateAssetTransactionResponse,
    UpdateAssetTransactionVariables
  >(AssetTransactionMutations.update, {
    onCompleted: res => {
      handleClose();
    },
    onError: res => setError(res.message),
  });

  const handleClose = () => {
    setInput(new AssetInput({ ...asset, product: { ...asset.product, quantity: 1, unitQuantity: '1' } }));
    setOpen(false);
    setError('');
  };

  const handleUpdate = async () => {
    try {
      await update({
        variables: {
          transactions: [input.forUpdate()],
        },
      });
    } catch (e) {
      setError(String(e));
    }
  };

  const footer = () => (
    <Grid container marginTop={'auto'} justifyContent={'space-between'}>
      <Grid item></Grid>
      <Grid item>
        <Grid container columnSpacing={1}>
          <Grid item>
            <CancelButton disabled={updateLoading} onClick={handleClose} />
          </Grid>
          <Grid item>
            <UpdateButton onClick={handleUpdate} loading={updateLoading} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Modal open={open} error={error} onClose={handleClose} title={t(TranslationKey.assignAsset).singular.label}>
      <AssetInfoPane
        input={input}
        setInput={setInput}
        footer={footer}
        type={AssetInfoType.assign}
        availableQuantity={availableQuantity}
      />
    </Modal>
  );
}
